export const FETCH_EXPLORE_POSTS_REQUEST = "FETCH_EXPLORE_POSTS_REQUEST";
export const FETCH_EXPLORE_POSTS_SUCCESS = "FETCH_EXPLORE_POSTS_SUCCESS";
export const FETCH_EXPLORE_POSTS_FAILURE = "FETCH_EXPLORE_POSTS_FAILURE";
export const FETCH_VIDEO_CATEGORIES_SUCCESS = "FETCH_VIDEO_CATEGORIES_SUCCESS";
// export const FETCH_LOCATIONS_SUCCESS = "FETCH_LOCATIONS_SUCCESS";
// export const FETCH_LOCATIONS_FAILURE = "FETCH_LOCATIONS_FAILURE";
